import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-new-photo-validation',
  templateUrl: './new-photo-validation.component.html',
  styleUrls: ['./new-photo-validation.component.scss'],
})
export class NewPhotoValidationComponent  implements OnInit {

  constructor(private modalCtrl: ModalController,
    public translate: TranslateService,
  ) { }

  ngOnInit() {}



  goBack(){
    this.modalCtrl.dismiss()
  }

  continue(){
    this.modalCtrl.dismiss('newPhotoApproved')
  }
}
